// extracted by mini-css-extract-plugin
export default {"details":"Profile__details___wQ6PY","buttonField":"Profile__buttonField___1ha43"};